import { Injectable, Injector } from '@angular/core';
import { IAttachmentSource } from 'attachment-source-lib';
import { SectionFileDatasourceService } from 'file-datasource-service-lib';
import {
  IAuthService,
  IDataSourceApiService,
  IDocumentDestinationService,
  IEntityMetadataService,
  IEntityPathService,
  IEntityPickerService,
  IEntityTypeOption,
  IFileDataSourceApiService,
  IIconService,
  ISharedServiceProviderService,
} from 'interfaces-lib';
import { INamedEntityService } from 'named-entity-service-lib';
import { IRecipientInfoService } from 'recipient-info-service-lib';
import { Observable } from 'rxjs';
import { ITerminologyService } from 'terminology-lib';

@Injectable({ providedIn: 'root' })
export class SectionSharedServiceProviderService implements ISharedServiceProviderService {
  constructor(private injector: Injector) {}

  getAuthService(): IAuthService {
    throw new Error('Method not implemented.');
  }

  getDataSourceApiService(): IDataSourceApiService {
    throw new Error('Method not implemented.');
  }

  getEntityMetadataService(): IEntityMetadataService {
    throw new Error('Method not implemented.');
  }

  getIconService(): IIconService {
    throw new Error('Method not implemented.');
  }

  getAttachmentSourceService(): IAttachmentSource {
    throw new Error('Method not implemented.');
  }

  getEntityPickerService(): IEntityPickerService {
    throw new Error('Method not implemented.');
  }

  getRecipientInfoService(): IRecipientInfoService {
    throw new Error('Method not implemented.');
  }

  getTerminologyService(): ITerminologyService {
    throw new Error('Method not implemented.');
  }

  getNamedEntityService(): INamedEntityService {
    throw new Error('Method not implemented.');
  }

  getEntityPathService(): IEntityPathService {
    throw new Error('Method not implemented.');
  }

  getDocumentDestinationService(): IDocumentDestinationService {
    throw new Error('Method not implemented.');
  }

  getFileDataSourceApiService(): IFileDataSourceApiService {
    return this.injector.get(SectionFileDatasourceService);
  }

  getCorpId(_token: string): string {
    throw new Error('Method not implemented.');
  }

  getEntityTypeOptions(_: string): Observable<IEntityTypeOption[]> {
    throw new Error('Method not implemented.');
  }
}
